import { useContext, useEffect } from 'react';

import { route } from './constants';
import { ApplicationContext } from '../../../../../shared/source/context/context';

import type { FunctionComponent } from 'react';

export const OnboardingForwarder: FunctionComponent = () => {
    const { actions, applicationState } = useContext(ApplicationContext);
    const { location, myUserProfile } = applicationState;
    const { navigateTo } = actions;

    const isCurrentPageOnboarding = location.pathname.includes(route.patterns.onboarding);

    useEffect(() => {
        const myUserProfileExists = myUserProfile.get('exists').unwrapOr(undefined);

        if (myUserProfileExists === false && !isCurrentPageOnboarding) {
            navigateTo(route.patterns.onboarding);
        }
    }, [myUserProfile, isCurrentPageOnboarding, navigateTo]);

    return null;
};
